import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { useTranslation } from "@/i18n/useTranslation";

interface OfferCardProps {
  num: string;
  title: string;
  description: string;
  href: string;
  duration: string;
  icon: LucideIcon;
}

const OfferCard = ({ num, title, description, href, duration }: OfferCardProps) => {
  const { t } = useTranslation();

  return (
    <Link
      to={href}
      className="group block border-t border-border/15 py-12 md:py-14 transition-all duration-600 hover:bg-primary/[0.015] relative"
    >
      {/* Active left-border accent on hover — animated reveal */}
      <div className="absolute left-0 top-0 bottom-0 w-px bg-primary/0 group-hover:bg-primary/40 transition-all duration-600 origin-top scale-y-0 group-hover:scale-y-100" />

      <div className="grid grid-cols-1 md:grid-cols-[80px_1fr_auto] gap-4 md:gap-12 items-start pl-4 md:pl-0">
        <span className="font-mono text-[2.5rem] md:text-[3.5rem] font-light leading-none text-foreground/[0.03] group-hover:text-primary/12 transition-colors duration-600 hidden md:block">
          {num}
        </span>

        <div className="flex-1">
          <h3 className="text-[17px] md:text-[19px] font-display text-foreground mb-3.5 group-hover:text-primary transition-colors duration-500 tracking-[-0.01em]">
            {title}
          </h3>
          <p className="text-[15px] text-muted-foreground leading-[1.8] max-w-lg font-light">
            {description}
          </p>
          {/* Duration badge on mobile */}
          <span className="md:hidden inline-block mt-4 font-mono text-[10px] tracking-[0.12em] uppercase text-muted-foreground/25">{duration}</span>
        </div>

        <div className="flex items-center gap-5 text-muted-foreground/35 group-hover:text-foreground transition-all duration-500 self-center">
          <span className="hidden md:inline font-mono text-[10px] tracking-[0.12em] uppercase text-muted-foreground/25">{duration}</span>
          <span className="hidden md:inline font-mono text-[10px] tracking-[0.1em] uppercase">{t("offerCard.learnMore")}</span>
          <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform duration-500" />
        </div>
      </div>
    </Link>
  );
};

export default OfferCard;
